namespace Matrix.Data {
    export interface TranslationRow {
        FromDomain?: string;
        ToDomain?: string;
        FromCode?: string;
        ToCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace TranslationRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'FromDomain';
        export const localTextPrefix = 'Data.Translation';
        export const deletePermission = 'DataAdmin:Translation';
        export const insertPermission = 'DataAdmin:Translation';
        export const readPermission = 'Read:Translation';
        export const updatePermission = 'DataAdmin:Translation';

        export declare const enum Fields {
            FromDomain = "FromDomain",
            ToDomain = "ToDomain",
            FromCode = "FromCode",
            ToCode = "ToCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
